// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prod-mgr-container {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.prod-mgr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 16px;
}

.prod-mgr-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.prod-mgr-add-btn {
  background-color: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}

.prod-mgr-add-btn:hover {
  background-color: #48d1cc;
  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.25);
}

.prod-mgr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.prod-card {
  background: rgba(14, 27, 27, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  transition: all 0.25s ease;
}

.prod-card:hover {
  border-color: rgba(72, 209, 204, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px);
}

.prod-card__img-container {
  width: 100%;
  height: 140px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.prod-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.prod-card__placeholder {
  font-size: 32px;
  color: rgba(255, 255, 255, 0.15);
}

.prod-card__name {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.prod-card__sku {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  font-family: monospace;
}

.prod-card__desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.prod-card__details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
}

.prod-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  text-transform: capitalize;
}

.prod-badge--method {
  background: rgba(72, 209, 204, 0.12);
  color: #48d1cc;
}

.prod-badge--price {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.prod-badge--qty {
  background: rgba(245, 200, 66, 0.12);
  color: #f5c842;
}

.prod-card__actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 12px;
}

.prod-card__delete-btn {
  background: none;
  border: 1px solid rgba(255, 107, 107, 0.3);
  color: #ff6b6b;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.prod-card__delete-btn:hover {
  background: #ff6b6b;
  color: #ffffff;
  border-color: #ff6b6b;
}

/* Form Styles */
.prod-form-container {
  background: rgba(14, 27, 27, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: slideDown 0.25s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.prod-form-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.prod-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 768px) {
  .prod-form-grid {
    grid-template-columns: 1fr;
  }
}

.prod-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prod-form-group--full {
  grid-column: 1 / -1;
}

.prod-form-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.prod-form-input,
.prod-form-textarea {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #ffffff;
  padding: 10px 14px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  transition: all 0.2s ease;
}

.prod-form-input:focus,
.prod-form-textarea:focus {
  border-color: #3bb3ae;
  outline: none;
  background: rgba(255, 255, 255, 0.08);
}

.prod-form-textarea {
  resize: vertical;
  min-height: 80px;
}

.prod-form-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.prod-form-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #3bb3ae;
}

.prod-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 20px;
}

.prod-form-btn-save {
  background-color: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.prod-form-btn-save:hover:not(:disabled) {
  background-color: #48d1cc;
  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.2);
}

.prod-form-btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prod-form-btn-cancel {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.prod-form-btn-cancel:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
}

.prod-form-upload-container {
  display: flex;
  gap: 16px;
  align-items: center;
}

.prod-form-preview {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.prod-form-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.prod-form-empty-preview {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.2);
}

.prod-empty-state {
  text-align: center;
  padding: 40px;
  background: rgba(14, 27, 27, 0.3);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.45);
}

.prod-empty-state p {
  margin: 0;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Offerings/OfferingProductsManager.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB","sourcesContent":[".prod-mgr-container {\n  padding: 8px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.prod-mgr-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding-bottom: 16px;\n}\n\n.prod-mgr-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.prod-mgr-add-btn {\n  background-color: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 20px;\n  padding: 8px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 13px;\n}\n\n.prod-mgr-add-btn:hover {\n  background-color: #48d1cc;\n  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.25);\n}\n\n.prod-mgr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.prod-card {\n  background: rgba(14, 27, 27, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  position: relative;\n  transition: all 0.25s ease;\n}\n\n.prod-card:hover {\n  border-color: rgba(72, 209, 204, 0.3);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  transform: translateY(-2px);\n}\n\n.prod-card__img-container {\n  width: 100%;\n  height: 140px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.03);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.prod-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.prod-card__placeholder {\n  font-size: 32px;\n  color: rgba(255, 255, 255, 0.15);\n}\n\n.prod-card__name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.prod-card__sku {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.35);\n  font-family: monospace;\n}\n\n.prod-card__desc {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.4;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.prod-card__details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: auto;\n}\n\n.prod-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 12px;\n  text-transform: capitalize;\n}\n\n.prod-badge--method {\n  background: rgba(72, 209, 204, 0.12);\n  color: #48d1cc;\n}\n\n.prod-badge--price {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.prod-badge--qty {\n  background: rgba(245, 200, 66, 0.12);\n  color: #f5c842;\n}\n\n.prod-card__actions {\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 12px;\n}\n\n.prod-card__delete-btn {\n  background: none;\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  color: #ff6b6b;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.prod-card__delete-btn:hover {\n  background: #ff6b6b;\n  color: #ffffff;\n  border-color: #ff6b6b;\n}\n\n/* Form Styles */\n.prod-form-container {\n  background: rgba(14, 27, 27, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: slideDown 0.25s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.prod-form-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.prod-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n@media (max-width: 768px) {\n  .prod-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.prod-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.prod-form-group--full {\n  grid-column: 1 / -1;\n}\n\n.prod-form-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.prod-form-input,\n.prod-form-textarea {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: #ffffff;\n  padding: 10px 14px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.prod-form-input:focus,\n.prod-form-textarea:focus {\n  border-color: #3bb3ae;\n  outline: none;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.prod-form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.prod-form-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.prod-form-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #3bb3ae;\n}\n\n.prod-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 20px;\n}\n\n.prod-form-btn-save {\n  background-color: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 24px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.prod-form-btn-save:hover:not(:disabled) {\n  background-color: #48d1cc;\n  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.2);\n}\n\n.prod-form-btn-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.prod-form-btn-cancel {\n  background: none;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  border-radius: 8px;\n  padding: 10px 24px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.prod-form-btn-cancel:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.prod-form-upload-container {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.prod-form-preview {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.prod-form-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.prod-form-empty-preview {\n  font-size: 24px;\n  color: rgba(255, 255, 255, 0.2);\n}\n\n.prod-empty-state {\n  text-align: center;\n  padding: 40px;\n  background: rgba(14, 27, 27, 0.3);\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.prod-empty-state p {\n  margin: 0;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
